module.exports = __webpack_public_path__ + "media/images/icons/arrow-circle-top-9703aa05014022e7ba75ba02fd04549e.svg";